import type { TranslationDictionary } from "./types";

export const IT_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Nuovo",
    "app.newTaskAria": "Nuova chat",
    "sidebar.searchPlaceholder": "Richieste di ricerca o attività ID",
    "sidebar.filters": "Filtri attività",
    "sidebar.allRatios": "Tutti i rapporti",
    "sidebar.allOrientations": "Tutti gli orientamenti",
    "sidebar.allModes": "Tutte le modalità",
    "sidebar.allResolutions": "Tutte le risoluzioni",
    "sidebar.activeTasks": "Compiti attivi",
    "sidebar.topAnchors": "Navigazione in tempo migliore",
    "sidebar.bottomAnchors": "Navigazione del tempo inferiore",
    "sidebar.resize": "Ridimensiona la barra laterale",
    "batch.selected": "0 selezionato",
    "batch.selectedCount": "{count} selezionato",
    "batch.archivedCount": "Chat {count} archiviate",
    "batch.archiveFailed": "L'archiviazione batch non è riuscita",
    "batch.runningCannotDeleteSelected": "Le chat selezionate sono in esecuzione e non possono essere eliminate",
    "batch.deleteTitle": "Eliminare le {count} chat?",
    "batch.deleteMessage": "Ciò eliminerà anche i file image locali.",
    "batch.deleteSkippedDetail": "Le attività {count} in esecuzione verranno mantenute",
    "batch.deleteSkippedSuffix": ", {count} attività in esecuzione non eliminate",
    "batch.deletedCount": "{count} chat{skipped} eliminate",
    "batch.deleteFailed": "Eliminazione batch non riuscita",
    "action.archive": "Archivio",
    "action.delete": "Elimina",
    "action.cancel": "Annulla",
    "action.edit": "Modifica",
    "action.clear": "Chiaro",
    "action.paste": "Incolla",
    "action.find": "Trova",
    "action.replace": "Sostituisci",
    "action.close": "Chiudi",
    "action.confirm": "Conferma",
    "action.confirmQuestion": "Confermi l'azione?",
    "action.refresh": "Aggiorna",
    "action.save": "Salva",
    "action.add": "Aggiungi",
    "action.new": "Nuovo",
    "action.import": "Importa",
    "action.export": "Esportazione",
    "queue.empty": "Nessuna coda",
    "queue.emptyAria": "Stato della coda: nessuna attività in coda",
    "queue.jumpTitle": "Passa alle attività attive",
    "queue.emptyTitle": "Nessuna attività in coda",
    "queue.channel": "Canali {count}",
    "queue.availableChannels": "Canali disponibili {usable}/{total}",
    "queue.dispatching": "Pianificazione · attesa {waiting}",
    "queue.runningWaiting": "In esecuzione {running} · in attesa {waiting}",
    "queue.statusLabel": "Stato della coda: {text} · {channelText}. Fare clic per passare alle attività attive",
    "queue.runningActions": "Esecuzione di azioni della coda di attività",
    "queue.waitingActions": "Azioni della coda di attività in attesa",
    "queue.cancelRunning": "Annulla",
    "queue.cancelRunningTitle": "Annulla l'attività in esecuzione",
    "queue.dragWaiting": "Trascina per riordinare l'attività in attesa",
    "queue.dragSort": "Trascina per ordinare",
    "queue.moveUp": "Su",
    "queue.moveUpTitle": "Sposta l'attività in attesa verso l'alto",
    "queue.moveDown": "Giù",
    "queue.moveDownTitle": "Sposta l'attività in attesa verso il basso",
    "queue.promote": "In alto",
    "queue.promoteTitle": "Sposta l'attività in attesa in alto",
    "queue.promoteFailed": "Spostamento in alto non riuscito",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Elimina l'attività in attesa",
    "queue.deleteWaitingTitleConfirm": "Eliminare l'attività in attesa?",
    "queue.deleteWaitingMessage": "Questo lo rimuove dalla coda e dall'elenco della cronologia.",
    "queue.deleteQueuedFailed": "Impossibile eliminare l'attività in coda",
    "queue.queuedDeleted": "Attività in coda eliminata",
    "queue.cancelRunningConfirm": "Annulla attività",
    "queue.cancelRunningTitleConfirm": "Annullare l'attività in esecuzione?",
    "queue.cancelRunningMessage": "L'attività corrente verrà interrotta. La storia verrà mantenuta.",
    "queue.cancelRunningFailed": "Impossibile annullare l'attività",
    "queue.runningCancelled": "Attività annullata",
    "queue.reorderFailed": "Impossibile riordinare la coda",
    "queue.realtimeUpdateFailed": "Impossibile aggiornare lo stato in tempo reale",
    "queue.realtimeDisconnected": "La connessione allo stato in tempo reale è stata interrotta. Aggiorna la pagina per ripristinare.",
    "queue.readFailed": "Impossibile caricare la coda",
    "status.waiting": "In attesa",
    "status.shownActiveTasks": "Visualizzazione delle attività attive",
    "status.jsonCopied": "JSON copiato",
    "taskStatus.submitting": "Invio",
    "taskStatus.running": "Generazione",
    "taskStatus.runningWithElapsed": "Generazione · {elapsed}",
    "taskStatus.completed": "Completato",
    "taskStatus.partialFailed": "Parzialmente fallito",
    "taskStatus.failed": "Fallito",
    "taskStatus.queued": "In coda",
    "taskStatus.unknown": "Stato sconosciuto",
    "taskStatus.task": "Compito",
    "taskStatus.connectionInterrupted": "Connessione interrotta",
    "taskStatus.lastFailed": "Ultimo fallito",
    "taskStatus.waitingRetry": "{reason}, in attesa di riprovare (tentativo {attempt}/{max})",
    "taskStatus.retrying": "{reason}, nuovo tentativo (tentativo {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Tentativo {attempt}/{max}, non riprovabile",
    "taskStatus.manualRetryAvailable": "fermato; fallito images può essere riprovato manualmente",
    "taskStatus.waitingRetryShort": "In attesa",
    "taskStatus.retryingShort": "Riprovo",
    "taskStatus.nonRetryableShort": "Non riprovabile",
    "taskStatus.manualRetryShort": "Riprova manuale",
    "taskStatus.stoppedShort": "Fermato",
    "taskStatus.runtime": "Durata {duration}",
    "taskStatus.runtimeCompleted": "Durata {duration} · completato {time}",
    "taskStatus.completedAt": "Completato {time}",
    "taskCard.count": "{count} images",
    "taskCard.successCount": "riuscito {count}",
    "taskCard.failedCount": "non riuscito {count}",
    "taskCard.runningCount": "generando {count}",
    "taskCard.waitingCount": "in attesa {count}",
    "taskCard.textToImageThumb": "Miniatura dell'attività Text-to-image",
    "taskCard.imageToImageThumb": "Miniatura dell'attività Image-to-image",
    "taskCard.failedThumb": "Attività fallita",
    "taskCard.textBadge": "t",
    "taskMode.edit": "Modifica",
    "taskMode.generate": "Genera",
    "document.generatingQueue": "Generazione · coda {total}",
    "document.queuedWaiting": "In coda · in attesa {count}",
    "runFeedback.editing": "Modifica",
    "runFeedback.generating": "Generazione",
    "runFeedback.status": "{action}, trascorso {elapsed}",
    "footer.archive": "Archivio",
    "footer.archiveCount": "Archivio {count}",
    "footer.historyLibrary": "Storia",
    "historyLibrary.openFull": "Apri la libreria della cronologia completa",
    "history.documentTitle": "Storia - AGENTRA IMAGE",
    "history.back": "Torniamo al generatore",
    "history.title": "Storia",
    "history.loading": "Caricamento in corso",
    "history.total": "{total} attività · {archived} archiviate",
    "history.search": "Cerca",
    "history.searchPlaceholder": "Richieste di ricerca o attività ID",
    "history.clear": "Chiaro",
    "history.month": "Mese",
    "history.status": "Stato",
    "history.promptMode": "Modalità richiesta",
    "history.size": "Dimensioni",
    "history.quality": "Qualità",
    "history.ratio": "Rapporto",
    "history.orientation": "Orientamento",
    "history.backend": "Backend",
    "history.provider": "Fornitore",
    "history.archived": "Archiviato",
    "history.all": "Tutto",
    "history.allMonths": "Tutti i mesi",
    "history.allStatuses": "Tutti gli stati",
    "history.allPromptModes": "Tutte le modalità",
    "history.allSizes": "Tutte le taglie",
    "history.allQualities": "Tutte le qualità",
    "history.allRatios": "Tutti i rapporti",
    "history.ratioOther": "Altro",
    "history.allOrientations": "Tutti gli orientamenti",
    "history.allBackends": "Tutti i backend",
    "history.allProviders": "Tutti i fornitori",
    "history.unarchived": "Non archiviato",
    "history.archivedOnly": "Archiviato",
    "history.tasksAria": "Compiti storici",
    "history.taskListTitle": "Compiti storici",
    "history.browseNewest": "Sfoglia prima i più recenti",
    "history.view": "Visualizza",
    "history.grid": "Griglia",
    "history.list": "Elenco",
    "history.sort": "Ordina",
    "history.newest": "Prima il più recente",
    "history.oldest": "Prima il più vecchio",
    "history.refresh": "Aggiorna",
    "history.selectedCount": "{count} attività selezionate",
    "history.confirmDelete": "Conferma l'eliminazione",
    "history.detail": "Dettagli del compito",
    "history.detailTitle": "Compito di storia",
    "history.closeDetail": "Chiudi i dettagli dell'attività",
    "history.resizeFilters": "Ridimensiona la barra laterale del filtro",
    "history.resizeDetail": "Ridimensiona il riquadro dei dettagli",
    "history.detailEmpty": "Seleziona un'attività storica per visualizzare i dettagli",
    "history.loadingDetail": "Caricamento dettaglio...",
    "history.loadMore": "Carica di più",
    "history.loadingMore": "Caricamento...",
    "history.noMore": "Niente più compiti",
    "history.loadFailed": "Caricamento non riuscito. Aggiorna o continua a scorrere per riprovare",
    "history.summaryFailed": "Impossibile caricare il riepilogo",
    "history.tasksFailed": "Impossibile caricare le attività",
    "history.detailFailed": "Impossibile caricare i dettagli",
    "history.noMatches": "Nessuna attività corrispondente",
    "history.loadedCount": "{count} caricato",
    "history.windowNotice": "L'elenco montato è limitato alle attività {count}; scorrere verso l'alto o verso il basso per ripristinare le attività adiacenti su richiesta.",
    "history.selectTask": "Seleziona attività",
    "history.viewing": "Visualizzazione",
    "history.noPreview": "Nessuna anteprima images",
    "history.downloadAll": "Scarica ZIP",
    "history.downloadSelected": "Scarica selezionato",
    "history.deleteUnselected": "Elimina deselezionato",
    "history.confirmDeleteUnselected": "Conferma l'eliminazione deselezionata",
    "history.selected": "Selezionato",
    "history.select": "Seleziona",
    "history.downloadIndex": "Scarica {index}",
    "history.addReference": "Aggiungi riferimento",
    "history.outputActions": "Risultato image azioni",
    "history.inputReferences": "Riferimenti in ingresso",
    "history.inputReferenceIndex": "Riferimento ingresso {index}",
    "history.copyPrompt": "Copia richiesta",
    "history.copyPrompts": "Copia le istruzioni",
    "history.copyPromptShort": "Copia",
    "history.copyPromptPanel": "Copia {title}",
    "history.copyOutputPromptPanel": "Copia image {index} richiesta modificata",
    "history.copyTaskIds": "Copia gli ID attività",
    "history.reuseTask": "Visualizza nel generatore",
    "history.downloadTask": "Scarica",
    "history.downloadSelectedTasks": "Scaricamento in batch",
    "history.contextMenuLabel": "Menu contestuale delle attività di cronologia",
    "history.promptCopied": "Richiesta copiata",
    "history.promptsCopied": "Richieste copiate dalle attività {count}",
    "history.taskIdsCopied": "ID attività {count} copiati",
    "history.promptCopiedShort": "Copiato",
    "history.promptCopyFailed": "Impossibile copiare la richiesta",
    "history.promptCopyFailedShort": "Fallito",
    "history.noPrompt": "Questa attività non ha alcuna richiesta di copia",
    "history.noPromptShort": "Vuoto",
    "history.downloadStarted": "Download avviato",
    "history.batchDownloadStarted": "Download avviati per attività {count}",
    "history.noDownloadableOutputs": "Non scaricabile images",
    "history.confirmDeleteSelected": "Conferma l'eliminazione selezionata",
    "history.openPreview": "Apri anteprima",
    "history.closePreview": "Chiudi l'anteprima",
    "history.untitled": "Senza titolo",
    "history.promptCompare": "Confronto immediato",
    "history.promptOriginal": "Richiesta originale",
    "history.promptSubmitted": "Pronto ottimizzato",
    "history.promptRevised": "Risultato rivisto",
    "history.outputRevisedPromptTitle": "Image {index} prompt rivisto",
    "history.outputRevisedPromptNotice": "Ogni image ha il proprio prompt rivisto sotto image.",
    "history.promptEmpty": "Nessun contenuto",
    "history.promptMode.strict": "Rigoroso",
    "history.promptMode.original": "Originale",
    "history.promptMode.off": "Creativo",
    "history.quality.high": "Alto",
    "history.quality.medium": "Medio",
    "history.quality.low": "Basso",
    "history.quality.auto": "Automatico",
    "footer.batch": "Lotto",
    "footer.storage": "Stoccaggio",
    "footer.apiStatus": "Stato API: OK",
    "footer.version": "Versione {version}",
    "footer.versionInfo": "Informazioni sulla versione",
    "footer.versionLoading": "Versione...",
    "footer.updateBadge": "Nuova versione disponibile",
    "footer.updateAvailable": "Nuova versione {version}",
    "version.title": "Versione e aggiornamento",
    "version.loading": "Lettura dello stato della versione",
    "version.current": "Versione attuale",
    "version.latest": "Ultima versione",
    "version.source": "Durata",
    "version.sourcePortable": "Pacchetto portatile",
    "version.sourceSource": "Controllo della fonte",
    "version.upToDate": "Sei già sull'ultima versione",
    "version.updateAvailable": "La versione {version} è disponibile. Chiudi la finestra del server WebUI, quindi esegui il programma di aggiornamento per eseguire l'aggiornamento.",
    "version.noUpdater": "Questo runtime non è un pacchetto portatile, quindi il programma di aggiornamento non può essere avviato automaticamente.",
    "version.openUpdater": "Avvia l'aggiornamento",
    "version.release": "Visualizza la versione",
    "version.updaterStarted": "Avviato l'aggiornamento. Chiudi la finestra del server WebUI corrente, quindi segui le istruzioni del programma di aggiornamento.",
    "version.updaterFailed": "Impossibile avviare l'aggiornamento. Esegui manualmente lo script di aggiornamento dal pacchetto.",
    "notifications.title": "Notifiche",
    "notifications.unread": "Notifiche, {count} non lette",
    "notifications.unreadSummary": "{count} da leggere",
    "notifications.empty": "Nessuna notifica di attività",
    "notifications.taskFailed": "Attività fallita",
    "notifications.taskPartial": "Attività parzialmente completata",
    "notifications.taskCompleted": "Attività completata",
    "notifications.generationFailed": "La generazione è fallita",
    "notifications.successCount": "{count} riuscito",
    "notifications.resultAvailable": "Risultati disponibili",
    "notifications.failedCount": "{count} non riuscito",
    "notifications.systemUnsupported": "Questo browser non supporta le notifiche di sistema",
    "notifications.systemBlocked": "Le notifiche di sistema sono bloccate dal browser. Abilitali nelle impostazioni del browser.",
    "notifications.systemDenied": "Le notifiche di sistema non sono abilitate",
    "notifications.systemEnabled": "Notifiche di sistema abilitate",
    "notifications.taskMissing": "L'attività non esiste o è stata eliminata",
    "theme.label": "Tema",
    "theme.system": "Automatico",
    "theme.light": "Chiaro",
    "theme.dark": "Scuro",
    "language.label": "Lingua dell'interfaccia",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Origine autenticazione",
    "auth.checking": "Verifica autenticazione",
    "auth.missingCodexSession": "Nessuna sessione Codex rilevata",
    "auth.switchFailed": "Impossibile cambiare la fonte di autenticazione",
    "auth.sourceUnavailable": "{source} non disponibile",
    "auth.notActive": "Non attivo",
    "api.settings": "Impostazioni di sistema",
    "api.provider": "API fornitore",
    "imageInput.title": "Images",
    "imageInput.uploadAria": "Fai clic, rilascia o incolla images",
    "imageInput.uploadFull": "Fai clic, rilascia o incolla images",
    "imageInput.uploadCompact": "Aggiungi image",
    "imageInput.uploadSubtitle": "Riferimenti multipli images supportati",
    "imageInput.recent": "Caricamenti recenti",
    "imageInput.recentBadge": "Recente",
    "imageInput.uploadBadge": "Carica",
    "imageInput.addToGallery": "Aggiungi alla galleria",
    "imageInput.addToGalleryShort": "Galleria",
    "imageInput.removeImage": "Rimuovi image",
    "imageInput.editedBadge": "Modificato",
    "imageInput.editImage": "Modifica {name}",
    "imageInput.deletedRecent": "Caricamento recente eliminato",
    "imageInput.deletedGallery": "Galleria image eliminata",
    "recentAssets.defaultName": "Caricamento recente",
    "recentAssets.use": "Utilizza {name}",
    "recentAssets.delete": "Elimina {name}",
    "recentAssets.deleteTitle": "Eliminare il caricamento recente?",
    "recentAssets.deleteMessage": "Ciò rimuoverà image dai caricamenti recenti. Se è attualmente selezionato come ingresso image, verrà rimosso dall'ingresso corrente. Le attività storiche che fanno riferimento a questo caricamento recente perderanno l'anteprima dell'input. La galleria pubblica non è interessata.",
    "recentAssets.loadFailed": "Impossibile caricare i caricamenti recenti",
    "recentAssets.deleteFailed": "Impossibile eliminare il caricamento recente",
    "recentAssets.deleted": "Caricamento recente eliminato",
    "inputSource.uploadFallback": "Caricato image",
    "inputSource.galleryFallback": "Galleria image",
    "inputSource.focusPasteFallback": "{prefix}. L'input Image è focalizzato; premi {shortcut} per incollare images.",
    "inputSource.pastedCount": "Incollato {count} appunti images",
    "inputSource.droppedCount": "Aggiunto {count} eliminato images",
    "inputSource.dropImagesOnly": "Elimina solo i file image",
    "inputSource.clipboardUnsupported": "Questo browser non può leggere direttamente gli appunti",
    "inputSource.clipboardEmpty": "Nessun appunti images trovato",
    "inputSource.clipboardDenied": "Il browser ha bloccato l'accesso diretto agli appunti",
    "inputSource.clipboardReadFailed": "Impossibile leggere gli appunti",
    "status.missingGalleryReference": "Un riferimento alla galleria image è stato eliminato. Rimuovilo prima di generare.",
    "status.missingRecentReference": "Un riferimento al caricamento recente image è stato eliminato. Rimuovilo prima di generare.",
    "status.emptyPrompt": "Inserisci un messaggio",
    "status.editNeedsImage": "La modalità di modifica richiede almeno un image",
    "status.loadedTask": "Attività caricata {taskId}",
    "status.reusedTask": "Attività aperta {taskId} nel generatore",
    "status.loadingHistoryInputs": "Caricamento input storico images...",
    "status.historyInputLoadFailed": "Impossibile caricare l'input storico image: {url}",
    "referenceCollector.alreadyStaged": "Già messo in scena come riferimento",
    "referenceCollector.staged": "Stage {count} riferimento images",
    "referenceCollector.title": "Riferimenti in sospeso · {count}",
    "referenceCollector.addAll": "Aggiungi tutti i riferimenti",
    "referenceCollector.itemFallback": "Riferimento in attesa",
    "referenceCollector.remove": "Rimuovere il riferimento in sospeso",
    "referenceCollector.cleared": "I riferimenti in sospeso sono stati cancellati",
    "referenceCollector.added": "Aggiunto {count} riferimento images",
    "referenceCollector.addFailed": "Impossibile aggiungere riferimenti in sospeso",
    "referenceCollector.readFailed": "Impossibile leggere image: {status}",
    "gallery.quick": "Galleria veloce",
    "gallery.current": "Galleria della categoria corrente",
    "gallery.categories": "Categorie della galleria",
    "gallery.categoryPortrait": "Ritratto",
    "gallery.categoryCharacter": "Carattere",
    "gallery.categoryProduct": "Prodotto",
    "gallery.categoryPortraitRole": "Riferimento al ritratto",
    "gallery.categoryCharacterRole": "Riferimento al personaggio",
    "gallery.categoryProductRole": "Riferimento del prodotto",
    "gallery.referenceRole": "Riferimento image",
    "gallery.manage": "Gestisci galleria",
    "gallery.loadFailed": "Impossibile caricare la galleria",
    "gallery.imageOrderUpdateFailed": "Impossibile aggiornare l'ordine image",
    "gallery.imageOrderUpdated": "Image ordine aggiornato",
    "gallery.categoryName": "Nome della categoria",
    "gallery.categoryPromptRole": "Ruolo immediato",
    "gallery.categorySave": "Salva",
    "gallery.categoryDelete": "Elimina",
    "gallery.categoryLoadFailed": "Impossibile caricare le categorie",
    "gallery.categoryNameRequired": "Inserisci il nome di una categoria",
    "gallery.categoryCreateFailed": "Impossibile aggiungere la categoria",
    "gallery.categoryCreated": "Categoria aggiunta",
    "gallery.categorySaveFailed": "Impossibile salvare la categoria",
    "gallery.categorySaved": "Categoria salvata",
    "gallery.categoryDeleteTitle": "Eliminare la categoria della galleria?",
    "gallery.categoryDeleteMessage": "Images in questa categoria verrà spostato in un'altra categoria. La galleria images non verrà eliminata.",
    "gallery.categoryDeleteConfirm": "Elimina categoria",
    "gallery.categoryDeleteFailed": "Impossibile eliminare la categoria",
    "gallery.categoryDeletedMigrated": "Categoria \"{name}\" eliminata e images migrato",
    "gallery.categoryOrderUpdateFailed": "Impossibile aggiornare l'ordine delle categorie",
    "gallery.categoryOrderUpdated": "Ordine delle categorie aggiornato",
    "gallery.categoryFallback": "Categoria Galleria",
    "gallery.imageFallback": "Galleria image",
    "gallery.imageLoadFailed": "Impossibile caricare questo image",
    "gallery.editImageLoadFailed": "Impossibile caricare questo image per la modifica",
    "gallery.cannotAddImage": "Questo image non può essere aggiunto alla galleria",
    "gallery.nameRequired": "Inserisci il nome di una galleria",
    "gallery.saveFailed": "Impossibile salvare la galleria image",
    "gallery.savedAsReference": "Aggiunto alla galleria e passato al riferimento della galleria",
    "gallery.renameImage": "Rinomina la galleria image",
    "gallery.moveToCategory": "Sposta nella categoria",
    "gallery.categoryRequired": "Scegli una categoria di gallerie",
    "gallery.promptNoteTitle": "Nota di riferimento della Galleria",
    "gallery.updateFailed": "Impossibile aggiornare la galleria",
    "gallery.selectImageFile": "Scegli un file image",
    "gallery.replaceImageFailed": "Impossibile sostituire la galleria image",
    "gallery.replacedImage": "Sostituita la fonte image per \"{name}\"",
    "gallery.deleteImageTitle": "Eliminare la galleria image?",
    "gallery.deleteImageMessage": "I riferimenti alle attività cronologiche verranno visualizzati come eliminati.",
    "gallery.deleteFailed": "Impossibile eliminare la galleria image",
    "gallery.deletedSuffix": " (eliminato)",
    "gallery.editImageLabel": "Modifica galleria image",
    "gallery.fieldCategory": "Categoria",
    "gallery.fieldPromptNote": "Nota di riferimento",
    "gallery.fieldName": "Nome",
    "quickGallery.empty": "No {category} images",
    "promptGallery.remove": "Rimuovi @{name}",
    "prompt.title": "Richiedi",
    "prompt.editorLabel": "Richiedi",
    "prompt.placeholder": "Descrivi il image che desideri generare o modificare. Digita @ per i riferimenti alla galleria, # per i codici colore e ~ per i frammenti di prompt.",
    "prompt.run": "Genera",
    "prompt.runEdit": "Inizia a modificare",
    "prompt.runTitle": "Genera (Cmd+Invio)",
    "prompt.runEditTitle": "Inizia la modifica (Cmd+Invio)",
    "prompt.findPanel": "Trova e sostituisci prompt",
    "prompt.findText": "Trova testo",
    "prompt.replaceWith": "Sostituisci con",
    "prompt.findActions": "Trova e sostituisci le azioni",
    "prompt.countZero": "0 partite",
    "prompt.matchCount": "{count} corrisponde",
    "prompt.foundCount": "Trovate {count} corrispondenze",
    "prompt.noMatch": "Nessun testo corrispondente",
    "prompt.replacedCount": "Corrispondenze {count} sostituite",
    "prompt.closeFind": "Chiudi trova e sostituisci",
    "prompt.recentTemplates": "Modelli recenti",
    "prompt.manageTemplates": "Gestisci modelli",
    "promptModel.galleryHeader": "Riferimento image note:",
    "promptModel.galleryInstruction": "- Riferimento image {number}: galleria \"{name}\", ruolo: {role}. @{name} nel prompt si riferisce a questo image.{note}",
    "outputSettings.title": "Output",
    "output.mainModel": "Modello principale",
    "output.selectMainModel": "Seleziona il modello principale",
    "output.mainModelCustomForInput": "Utilizza un modello personalizzato per l'input corrente",
    "output.apiDirect": "API Diretto",
    "output.apiToolModel": "Utilizzando il modello API image",
    "output.mainModelUnused": "Il modello principale non è utilizzato per questa richiesta",
    "output.webSearch": "Ricerca sul Web",
    "output.webSearchToggle": "Su",
    "output.webSearchTitle": "Cerca prima sul Web, quindi utilizzalo per questa generazione; Solo Codex e API Responses",
    "output.promptMode": "Modalità richiesta",
    "output.modeOriginal": "Originale",
    "output.modeStrict": "Fedele",
    "output.modeCreative": "Creativo",
    "output.sizeMode": "Modalità dimensione",
    "output.sizePreset": "Preimpostato",
    "output.sizeCustom": "Personalizzato",
    "output.orientation": "Orientamento",
    "output.square": "Quadrato",
    "output.portrait": "Ritratto",
    "output.landscape": "Paesaggio",
    "output.resolution": "Risoluzione",
    "output.pixelSize": "Dimensione pixel",
    "output.width": "Larghezza",
    "output.height": "Altezza",
    "output.swapSize": "Scambia larghezza e altezza",
    "output.customSizeHint": "Unità px · 16-3840 · multiplo di 16 · ≤3:1",
    "output.imageSizeUnavailable": "Image taglia non disponibile",
    "output.imageLoadFailed": "Impossibile caricare Image",
    "output.customSizeRequired": "Inserisci larghezza e altezza",
    "output.customSizeBounds": "La larghezza e l'altezza devono essere comprese tra 16 e 3840 px",
    "output.customSizeMultiple": "La larghezza e l'altezza devono essere multipli di 16",
    "output.customSizeRatio": "Il rapporto lato lungo-corto non può superare 3:1",
    "output.customSizePixels": "I pixel totali devono essere 655.360-8.294.400",
    "output.ratioLock": "Blocco del rapporto (opzionale)",
    "output.customRatio": "Proporzioni personalizzate",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Utilizza le prime proporzioni di riferimento image",
    "output.useFirstImage": "Da image",
    "output.ratioHint": "Lascia vuoto per la dimensione libera · Compila entrambi per sincronizzare",
    "output.ratio": "Rapporto",
    "output.quality": "Qualità",
    "output.qualityAuto": "Automatico",
    "output.qualityLow": "Basso",
    "output.qualityMedium": "Medio",
    "output.qualityHigh": "Alto",
    "output.quantity": "Conte",
    "output.pixelPreview": "Pixel di output: 1024 x 1024 px",
    "output.pixelPreviewValue": "Pixel di output: {value}",
    "output.pixelPreviewAuto": "Pixel di output: auto (OpenAI sceglie automaticamente)",
    "output.format": "Formato",
    "output.compression": "Compressione",
    "output.moderation": "Moderazione",
    "preview.title": "Anteprima",
    "preview.selectedZero": "0 selezionato",
    "preview.selectedCount": "Selezionato {selected}/{total}",
    "preview.downloadSelected": "Scarica selezionato",
    "preview.deleteUnselected": "Elimina deselezionato",
    "preview.downloadAll": "Scarica ZIP",
    "preview.empty": "Nessun images ancora",
    "preview.taskFailed": "Attività fallita",
    "preview.partialFailed": "Alcuni images non sono riusciti",
    "preview.failedOutput": "Image {index} non riuscito",
    "preview.progressLine": "Completato {generated} / {total} · trascorso {elapsed}",
    "preview.failureLine": "Completato {generated} / {total} · fallito {failed}",
    "preview.elapsedLine": "Trascorso {elapsed}",
    "preview.lastError": "Ultimo errore: {error}",
    "preview.continueGenerating": "Generazione continua",
    "preview.waitingContinue": "In attesa di continuare",
    "preview.retryFailed": "Nuovo tentativo non riuscito images",
    "preview.acceptSuccesses": "Accetta i risultati positivi",
    "preview.generateMode": "Generazione",
    "preview.editMode": "Modifica",
    "preview.runningTitle": "{mode} in esecuzione",
    "preview.submittingTitle": "Invio attività",
    "preview.queuedTitle": "Attività in coda",
    "preview.submittingDetail": "Salvataggio degli input e aggiunta dell'attività alla coda. La generazione inizierà automaticamente.",
    "preview.queuedDetail": "L'attività è in coda e attende un canale disponibile.",
    "preview.featured": "Selezionato",
    "preview.addFeatured": "Seleziona il risultato",
    "preview.selectedFeatured": "Selezionato",
    "preview.removeFeatured": "Deseleziona il risultato",
    "preview.selectionAdded": "Risultato selezionato",
    "preview.selectionRemoved": "Risultato deselezionato",
    "preview.selectionUpdateFailed": "Impossibile aggiornare la selezione",
    "preview.noUnselectedOutputs": "Nessun images deselezionato da eliminare",
    "preview.deleteUnselectedTitle": "Eliminare images non selezionato?",
    "preview.deleteUnselectedMessage": "Ciò eliminerà i file image locali per i risultati non selezionati in questa attività.",
    "preview.deleteUnselectedDetail": "Mantieni {selected}, elimina {deleted}",
    "preview.deleteUnselectedFailed": "Impossibile eliminare images non selezionato",
    "preview.deleteUnselectedDone": "Deselezionato images eliminato",
    "preview.addReference": "Aggiungi riferimento",
    "preview.stage": "Palcoscenico",
    "preview.stageReference": "Stage come riferimento in sospeso",
    "preview.prompt": "Richiedi",
    "preview.download": "Scarica",
    "preview.downloadImage": "Scarica questo image",
    "lightbox.label": "Image anteprima",
    "lightbox.close": "Chiudi l'anteprima",
    "lightbox.previous": "Precedente image",
    "lightbox.next": "Successivo image",
    "promptPopover.title": "Confronto immediato",
    "promptPopover.summary": "Originale {original} · ottimizzato {optimized}",
    "promptPopover.original": "Richiesta originale",
    "promptPopover.optimized": "Pronto ottimizzato",
    "promptPopover.charCount": "{count} caratteri",
    "promptPopover.empty": "Nessuno",
    "promptPopover.notReturned": "Non restituito",
    "promptPopover.noOptimized": "Nessun prompt ottimizzato restituito",
    "promptPopover.submitted": "Visualizza la richiesta inviata",
    "promptPopover.close": "Chiudi il confronto immediato",
    "promptPopover.copyOptimized": "Copia prompt ottimizzato",
    "promptPopover.copied": "Copiato",
    "taskContext.menuLabel": "Menu contestuale delle attività",
    "taskContext.view": "Visualizza attività",
    "taskContext.copyId": "Copia attività ID",
    "taskContext.copyPrompt": "Copia richiesta",
    "taskContext.revealOutput": "Apri la cartella di output",
    "taskContext.archive": "Attività di archiviazione",
    "taskContext.delete": "Elimina attività",
    "taskContext.idCopied": "Task ID copiato",
    "taskContext.promptCopied": "Richiesta copiata",
    "taskContext.noPrompt": "Questa attività non ha alcuna richiesta di copia",
    "taskContext.revealFailed": "Impossibile aprire la cartella di output",
    "taskContext.revealOpened": "Cartella di output aperta",
    "taskContext.actionFailed": "Azione dell'attività non riuscita",
    "taskActions.group": "Azioni del compito",
    "taskActions.deleteTitle": "Eliminare l'attività?",
    "taskActions.deleteMessage": "Ciò eliminerà anche i file image locali.",
    "taskActions.runningCannotDelete": "Le attività in esecuzione non possono essere eliminate",
    "taskActions.updated": "Stato dell'attività aggiornato",
    "taskActions.archived": "Chat archiviata",
    "taskActions.archiveFailed": "Archivio non riuscito",
    "taskActions.deleted": "Attività eliminata",
    "taskActions.deleteFailed": "Eliminazione non riuscita",
    "taskActions.noRetryableFailedImages": "Nessun tentativo images fallito per questa attività",
    "taskActions.retryFailedOutputsFailed": "Impossibile riprovare non riuscito images",
    "taskActions.requeuedFailedImages": "Errore images riaccodato",
    "taskActions.noAcceptableSuccessImages": "Questa attività non ha images riuscito da accettare",
    "taskActions.acceptSuccessesFailed": "Impossibile accettare risultati positivi",
    "taskActions.acceptedSuccesses": "Risultati positivi accettati",
    "taskActions.viewedUpdateFailed": "Impossibile aggiornare lo stato di lettura",
    "taskActions.failedFallback": "Attività fallita",
    "taskList.empty": "Nessuna storia ancora",
    "taskList.selectSession": "Seleziona chatta",
    "taskList.unreadUpdate": "Aggiornamento non letto",
    "taskList.viewing": "Visualizzazione",
    "taskDerived.usageLimited": "Utilizzo limitato",
    "taskSubmit.requestFailed": "Richiesta non riuscita",
    "taskSubmit.queued": "Attività aggiunta alla coda",
    "taskSubmit.timeout": "L'invio dell'attività è scaduto prima che il backend rispondesse. Aggiorna la coda per confermare se è stata aggiunta, quindi decidi se riprovare.",
    "taskSubmit.failed": "Invio dell'attività non riuscito",
    "templates.title": "Modelli di prompt",
    "templates.summary": "Libreria di modelli locale",
    "templates.availableCount": "{count} modelli disponibili",
    "templates.noMatch": "Nessun modello corrispondente",
    "templates.empty": "Nessun modello",
    "templates.favoriteBadge": "Preferito",
    "templates.usageCount": "{count} utilizza",
    "templates.back": "Indietro",
    "templates.edit": "Modifica",
    "templates.copy": "Copia",
    "templates.insert": "Inserisci",
    "templates.formTitle": "Titolo",
    "templates.formShortTitle": "Titolo breve",
    "templates.formCategory": "Categoria",
    "templates.formTags": "Tag",
    "templates.formThumbnail": "Miniatura",
    "templates.formContent": "Contenuto",
    "templates.formNotes": "Note",
    "templates.formFavorite": "Preferito",
    "templates.thumbnailClear": "Chiaro",
    "templates.thumbnailNone": "Nessuno selezionato",
    "templates.thumbnailEmpty": "Nessuna miniatura della cronologia",
    "templates.newCategory": "Nuova categoria",
    "templates.search": "Cerca modelli, tag o contenuti",
    "templates.filter": "Filtri dei modelli",
    "templates.all": "Tutto",
    "templates.categoryCommon": "Comune",
    "templates.categoryPortrait": "Ritratto",
    "templates.categoryProduct": "Prodotto",
    "templates.categoryRepair": "Riparazione",
    "templates.categoryPoster": "Manifesto",
    "templates.categoryEcommerce": "Commercio elettronico",
    "templates.favorite": "Preferiti",
    "templates.recent": "Recente",
    "templates.category": "Categorie",
    "templates.loadFailed": "Impossibile caricare i modelli di prompt",
    "templates.useStateUpdateFailed": "Impossibile aggiornare lo stato di utilizzo del modello di richiesta",
    "templates.copied": "Modello di richiesta copiato",
    "templates.copyFailed": "Impossibile copiare il modello di richiesta",
    "templates.history": "Storia",
    "templates.saveFailed": "Impossibile salvare il modello di richiesta",
    "templates.saved": "Modello di richiesta salvato",
    "templates.deleteFailed": "Impossibile eliminare il modello di richiesta",
    "templates.deleted": "Modello di richiesta eliminato",
    "templates.categoryAddFailed": "Impossibile aggiungere la categoria del modello",
    "templates.categoryAdded": "Categoria modello aggiunta",
    "templates.categorySaveFailed": "Impossibile salvare la categoria del modello",
    "templates.categorySaved": "Categoria modello salvata",
    "templates.categoryDeleteFailed": "Impossibile eliminare la categoria del modello",
    "templates.categoryDeleted": "Categoria modello eliminata",
    "templates.importFailed": "Impossibile importare il pacchetto di modelli",
    "templates.importedCount": "Modelli {count} importati",
    "templates.exportFailed": "Impossibile esportare il pacchetto di modelli",
    "templates.exported": "Pacchetto modelli esportato",
    "snippets.suggestLabel": "Selettore di frammenti di richiesta",
    "snippets.saveSelection": "Salva",
    "snippets.saveSelectionLabel": "Salva il testo selezionato come frammento di prompt",
    "snippets.popoverLabel": "Frammento di richiesta",
    "snippets.defaultCategory": "Comune",
    "snippets.loadFailed": "Impossibile caricare gli snippet del prompt",
    "snippets.remove": "Rimuovi ~{tag}",
    "snippets.expand": "Espandi",
    "snippets.edit": "Modifica",
    "snippets.close": "Chiudi",
    "snippets.editTitle": "Modifica frammento",
    "snippets.saveTitle": "Salva frammento",
    "snippets.shortTag": "Etichetta breve",
    "snippets.title": "Titolo",
    "snippets.category": "Categoria",
    "snippets.content": "Contenuto",
    "snippets.titlePlaceholder": "Utilizza il tag breve per impostazione predefinita",
    "snippets.cancel": "Annulla",
    "snippets.save": "Salva",
    "snippets.saveFailed": "Impossibile salvare lo snippet del prompt",
    "snippets.saved": "Frammento di richiesta salvato",
    "snippets.defaultTag": "Frammento comune",
    "colors.white": "Bianco",
    "colors.black": "Nero",
    "colors.warmBeige": "Beige caldo",
    "colors.lightGreen": "Verde chiaro",
    "colors.brandGreen": "Marchio verde",
    "colors.peachOrange": "Arancia pesca",
    "colors.lightBlue": "Azzurro",
    "colors.lightPink": "Rosa chiaro",
    "colors.loadFailed": "Impossibile caricare le impostazioni del colore",
    "colors.saveFailed": "Impossibile salvare le impostazioni del colore",
    "colors.importFailed": "Impossibile importare le impostazioni del colore",
    "colors.importedCount": "Colori {count} importati",
    "colors.recentSaveFailed": "Impossibile salvare i colori recenti",
    "colors.favoriteSaveFailed": "Impossibile salvare il colore preferito",
    "colors.favoriteDeleteFailed": "Impossibile eliminare il colore preferito",
    "colors.update": "Aggiorna",
    "colors.insert": "Inserisci",
    "colors.pick": "Scegli il colore",
    "colors.pickShort": "Scegli",
    "colors.hexValue": "Valore del colore",
    "colors.pendingUpdate": "Il colore è cambiato. Fare clic su Aggiorna per applicare.",
    "colors.save": "Salva",
    "colors.exportPs": "Esportazione",
    "colors.importPs": "Importa",
    "colors.done": "Fatto",
    "colors.manage": "Gestisci",
    "colors.favorites": "Colori preferiti",
    "colors.recent": "Colori recenti",
    "colors.recentLabel": "Recente",
    "colors.deleteFavorite": "Elimina colore preferito {name}",
    "colors.modify": "Modifica colore",
    "colors.modifyValue": "Modifica colore {value}",
    "colors.removeValue": "Rimuovi colore {value}",
    "taskGroup.today": "Oggi",
    "taskGroup.yesterday": "Ieri",
    "taskGroup.last7": "Ultimi 7 giorni",
    "taskGroup.older": "Più vecchio",
    "taskGroup.searchResults": "Risultati della ricerca",
    "taskGroup.active": "Attivo",
    "taskGroup.running": "Correre",
    "taskGroup.waiting": "In attesa",
    "taskGroup.dispatchPending": "Assegnazione di un canale disponibile...",
    "taskGroup.expand": "Espandi {label}",
    "taskGroup.collapse": "Comprimi {label}",
    "taskGroup.buttonLabel": "{label}, {count} attività",
    "archive.title": "Archivio",
    "archive.empty": "Nessuna chat archiviata",
    "archive.count": "{count} chat archiviate",
    "archive.restore": "Ripristina",
    "archive.archiveFailed": "Archivio non riuscito",
    "archive.restoreFailed": "Ripristino non riuscito",
    "archive.restored": "Chat ripristinata",
    "archive.archiving": "Archiviazione...",
    "archive.restoring": "Ripristino...",
    "archive.deleting": "Eliminazione...",
    "archive.restoredCount": "Attività {count} ripristinate",
    "settings.title": "Stoccaggio",
    "settings.status": "Riavvia WebUI dopo aver salvato i percorsi di archiviazione",
    "settings.inputRoot": "Cartella di input",
    "settings.outputRoot": "Cartella di output",
    "settings.galleryRoot": "Cartella Galleria",
    "settings.sourceDataRoot": "Cartella dati di origine",
    "settings.chooseDirectory": "Scegli cartella",
    "settings.language": "Lingua dell'interfaccia",
    "settings.languageCopy": "Al primo avvio, l'interfaccia segue la lingua del browser. Le scelte manuali vengono ricordate.",
    "settings.notificationsCopy": "Avvisa quando le attività vengono completate o falliscono. Le notifiche di sistema devono essere abilitate manualmente.",
    "settings.inAppNotification": "Notifiche nell'app",
    "settings.systemNotification": "Notifiche di sistema",
    "settings.save": "Salva impostazioni",
    "settings.loadFailed": "Impossibile caricare le impostazioni",
    "settings.saveFailed": "Impossibile salvare le impostazioni",
    "settings.savedRestart": "Impostazioni di archiviazione salvate. Riavvia WebUI per applicare.",
    "settings.saved": "Salvato",
    "settings.savedRestartStatus": "Impostazioni di archiviazione salvate. Riavvia WebUI per applicare.",
    "systemSettings.title": "Impostazioni di sistema",
    "systemSettings.tabsLabel": "Sezioni delle impostazioni di sistema",
    "systemSettings.apiTab": "API Impostazioni",
    "systemSettings.codexTab": "Codex Canale",
    "systemSettings.languageTab": "Lingua / Language",
    "systemSettings.storageTab": "Notifiche",
    "languageSettings.instantStatus": "Salvato. Applicato subito.",
    "apiSettings.title": "API Impostazioni",
    "apiSettings.status": "Le impostazioni salvate vengono applicate immediatamente in modalità API",
    "apiSettings.codexMode": "canale Codex",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API fornitori",
    "apiSettings.providerCount": "{count} fornitori",
    "apiSettings.provider": "Fornitore",
    "apiSettings.providerName": "Nome del fornitore",
    "apiSettings.newProviderAction": "Nuovo fornitore",
    "apiSettings.copyProvider": "Copia",
    "apiSettings.copyProviderName": "{name} Copia",
    "apiSettings.copyProviderStatus": "Provider copiato con la chiave salvata. Modifica il nome, il modello o sostituisci la chiave prima di salvare.",
    "apiSettings.copyProviderWithoutKeyStatus": "Fornitore copiato. Modifica il nome, il modello o aggiungi una chiave API prima di salvare.",
    "apiSettings.sortProviders": "Ordina",
    "apiSettings.finishSortProviders": "Fatto",
    "apiSettings.sortProviderModeStatus": "Ordinamento dei fornitori",
    "apiSettings.sortProviderStatus": "L'ordine dei fornitori è cambiato. Salva la selezione corrente per sincronizzarla.",
    "apiSettings.moveProviderUp": "Su",
    "apiSettings.moveProviderDown": "Giù",
    "apiSettings.moveProviderUpAria": "Sposta {provider} in alto",
    "apiSettings.moveProviderDownAria": "Sposta {provider} giù",
    "apiSettings.mode": "Modalità di richiesta",
    "apiSettings.images": "Diretto Image API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Diretto",
    "apiSettings.imageModel": "modello Image",
    "apiSettings.concurrency": "Limite di concorrenza del provider",
    "apiSettings.concurrencyShort": "Concorrenza",
    "apiSettings.concurrencyValue": "concorrenza {concurrency}",
    "apiSettings.keySaved": "Chiave API salvata",
    "apiSettings.keyNotSet": "Chiave API non impostata",
    "apiSettings.editProvider": "Modifica fornitore",
    "apiSettings.newProviderTitle": "Nuovo fornitore",
    "apiSettings.editHint": "Il provider di salvataggio scrive questa modifica sul backend. Annulla lo scarta.",
    "apiSettings.finishEditFirst": "Prima salva o annulla la modifica del fornitore corrente",
    "apiSettings.newDraftStatus": "Creazione fornitore. Salva il fornitore per candidarti.",
    "apiSettings.editDraftStatus": "Fornitore di editing. Salva il fornitore per candidarti.",
    "apiSettings.cancelEdit": "Annulla modifica",
    "apiSettings.saveProvider": "Salva fornitore",
    "apiSettings.saveSelection": "Salva la selezione",
    "apiSettings.deleteProviderTitle": "Eliminare il fornitore?",
    "apiSettings.deleteProviderMessage": "Eliminare \"{provider}\"?",
    "apiSettings.deleteProviderDetail": "Questo lo rimuove dall'elenco dei provider. Salva la selezione corrente per sincronizzarla con il backend.",
    "apiSettings.deleteProviderStatus": "Fornitore eliminato. Salva la selezione corrente per sincronizzarla con il backend.",
    "apiSettings.save": "Salva le impostazioni API",
    "apiSettings.loadFailed": "Impossibile caricare le impostazioni API",
    "apiSettings.savedKeyPlaceholder": "La chiave API viene salvata sul back-end. Immettere una nuova chiave per sostituirla.",
    "apiSettings.newProvider": "Nuovo fornitore",
    "apiSettings.saving": "Salvataggio...",
    "apiSettings.savingStatus": "Salvataggio delle impostazioni API...",
    "apiSettings.saveFailed": "Impossibile salvare le impostazioni API",
    "apiSettings.savedSummary": "Salvato · Codex {codex} · API {provider} · {mode} · {model} · concorrenza {concurrency}",
    "apiSettings.savedShort": "Salvato",
    "apiSettings.savedStatus": "API impostazioni salvate",
    "apiSettings.saveFailedShort": "Salvataggio non riuscito",
    "codexSettings.title": "Codex Canale",
    "codexSettings.status": "Scegli il canale di generazione per l'accesso Codex locale",
    "codexSettings.notesLabel": "Codex note sul canale",
    "codexSettings.imagesTitle": "Image",
    "codexSettings.imagesCopy": "Canale predefinito per il passaggio diretto di dimensioni, qualità e modifica dei parametri.",
    "codexSettings.responsesTitle": "Responses",
    "codexSettings.responsesCopy": "Canale di compatibilità per flussi di lavoro che necessitano di strumenti di ricerca Web.",
    "codexSettings.save": "Salva il canale Codex",
    "imageEditor.title": "Modifica input Image",
    "imageEditor.promptHint": "Le frecce e i segni disegnati a mano nel image sono solo istruzioni. Non tenerli nel finale image.",
    "imageEditor.inputFallback": "Ingresso image",
    "imageEditor.openFailed": "Impossibile aprire questo image per la modifica",
    "imageEditor.loadForEditFailed": "Impossibile caricare questo image per la modifica",
    "imageEditor.canvasCreateFailed": "Impossibile creare l'area di modifica image",
    "imageEditor.closedRegionRequired": "Usa il pennello per disegnare prima una regione chiusa",
    "imageEditor.saveFailed": "Impossibile salvare la modifica image",
    "imageEditor.saved": "Ingresso modificato image salvato",
    "imageEditor.uneditable": "Questo image non può essere modificato",
    "imageEditor.resetDone": "Ripristina a original image",
    "imageEditor.resetFailed": "Impossibile reimpostare original image",
    "imageEditor.subtitle": "Ritaglia, disegna, riempi o aggiungi frecce, quindi salva come nuovo input image",
    "imageEditor.toolbar": "Barra degli strumenti dell'editor Image",
    "imageEditor.tools": "Strumenti",
    "imageEditor.select": "Seleziona",
    "imageEditor.brush": "Pennello",
    "imageEditor.arrow": "Freccia",
    "imageEditor.crop": "Ritaglia",
    "imageEditor.fill": "Riempi",
    "imageEditor.fillLabel": "Riempimento del secchio di vernice",
    "imageEditor.eraser": "Gomma",
    "imageEditor.colors": "Colori",
    "imageEditor.red": "Rosso",
    "imageEditor.blue": "Blu",
    "imageEditor.green": "Verde",
    "imageEditor.yellow": "Giallo",
    "imageEditor.white": "Bianco",
    "imageEditor.black": "Nero",
    "imageEditor.customColor": "Colore personalizzato",
    "imageEditor.stroke": "Ictus",
    "imageEditor.history": "Storia",
    "imageEditor.undo": "Annulla",
    "imageEditor.redo": "Rifare",
    "imageEditor.reset": "Reimposta image",
    "imageEditor.canvas": "Image modifica tela",
    "imageEditor.canvasScope": "Area della tela",
    "imageEditor.canvasScopeBase": "Immagine base",
    "imageEditor.canvasScopeFit": "Adatta ai livelli",
    "imageEditor.canvasFitDone": "Tela adattata all'area dei livelli",
    "imageEditor.canvasBaseDone": "Tela ripristinata all'immagine base",
    "imageEditor.insertImages": "Inserisci immagini",
    "imageEditor.layers": "Livelli",
    "imageEditor.layerUp": "Sposta su",
    "imageEditor.layerDown": "Sposta giù",
    "imageEditor.emptyInsertList": "Nessun'altra immagine di input",
    "imageEditor.selectLayerFirst": "Seleziona prima un livello",
    "imageEditor.baseLayer": "Immagine base",
    "gallery.title": "Galleria",
    "gallery.subtitle": "Scegli il riferimento images per l'attività corrente",
    "gallery.manageCategories": "Gestisci le categorie",
    "gallery.categoryManager": "Gestisci le categorie della galleria",
    "gallery.categoryManagement": "Gestione delle categorie",
    "gallery.categoryCopy": "Le categorie vengono salvate nella galleria; i ruoli prompt descrivono come vengono utilizzati i riferimenti.",
    "gallery.newCategoryName": "Nuovo nome della categoria",
    "gallery.newCategoryRole": "Ruolo rapido, ad es. riferimento di stile",
    "gallery.addCategory": "Aggiungi categoria",
    "gallery.drawerSubtitle": "Categoria attuale: {category}. Fai clic su \"Usa\" per aggiungerlo all'input image.",
    "gallery.emptyCategory": "Nessun images ancora in questa categoria",
    "gallery.dragSort": "Trascina per ordinare",
    "gallery.dragSortImage": "Ordina tramite trascinamento image {name}",
    "gallery.dragSortCategory": "Categoria di ordinamento tramite trascinamento {name}",
    "gallery.use": "Utilizzare",
    "gallery.replace": "Sostituisci",
    "gallery.rename": "Rinominare",
    "gallery.moveCategory": "Categoria",
    "gallery.note": "Nota",
    "gallery.delete": "Elimina",
    "gallery.uncategorized": "Senza categoria",
    "addGallery.title": "Aggiungi alla Galleria",
    "addGallery.copy": "I nomi sono univoci a livello globale e in seguito è possibile fare riferimento a @name",
    "addGallery.name": "Nome",
    "addGallery.namePlaceholder": "Esempio: Mia",
    "addGallery.category": "Categoria",
    "addGallery.note": "Nota di riferimento",
    "addGallery.notePlaceholder": "Esempio: fare riferimento solo al viso e ai capelli, non ai vestiti o allo sfondo",
    "addGallery.save": "Salva nella galleria",
    "close.promptTemplates": "Chiudi il pannello dei modelli di prompt",
    "close.archive": "Chiudi il pannello archivio",
    "close.settings": "Chiudi il pannello delle impostazioni di archiviazione",
    "close.apiSettings": "Chiudi il pannello delle impostazioni API",
    "close.systemSettings": "Chiudi il pannello delle impostazioni di sistema",
    "close.imageEditor": "Chiudi il pannello dell'editor image",
    "close.gallery": "Chiudi il pannello della galleria",
    "close.addGallery": "Chiudi Aggiungi al pannello Galleria",
    "close.version": "Chiudi il pannello di aggiornamento della versione"
};


